import { render } from "./PermissionView.vue?vue&type=template&id=668024ec&scoped=true"
import script from "./PermissionView.vue?vue&type=script&lang=js"
export * from "./PermissionView.vue?vue&type=script&lang=js"

import "./PermissionView.vue?vue&type=style&index=0&id=668024ec&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668024ec"]])

export default __exports__